import { PreloadingStrategy, Route, Router } from '@angular/router';

import { Observable, of, timer, mergeMap, tap, from } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { kzMark } from '@shared/util/kz-perf';
import { afterFirstNavigation } from '@shared/util/after-first-navigation';

/**
 * custom implementation for preloading lazy modules in spefic order
 * controlled by preload and delay params. this can help control
 * the case of two lazy modules(A & B) were where B depends on the
 * stored state of A so requires that A be loaded before B.
 * each lazy route is required to have and extra data param of type:
 *  data: { preload: boolean, delay: boolean }
 * see referenced [site](https://medium.com/@adrianfaciu/custom-preloading-strategy-for-angular-modules-b3b5c873681a)
 * and [site](https://www.tektutorialshub.com/angular/angular-preloading-strategy/)
 *
 * kz2 M12 (R11 H): nothing is preloaded before the first navigation has settled AND the browser is
 * idle — the preloads used to start at the first NavigationEnd, together with the page they competed with.
 */
@Injectable()
export class AppPreloadingStrategy implements PreloadingStrategy {
  private readonly router = inject(Router, { optional: true });

  preload(route: Route, loadMe: () => Observable<any>): Observable<any> {
    if (!route.data?.preload) {
      return of(null);
    }
    const load = () => {
      kzMark('preload:start', route.path);
      return loadMe().pipe(tap({ complete: () => kzMark('preload:end', route.path) }));
    };
    return from(afterFirstNavigation(this.router)).pipe(
      mergeMap(() => (route.data?.delay ? timer(150).pipe(mergeMap(() => load())) : load())),
    );
  }
}

// @Injectable()
// export class CustomPreloadingStrategy implements PreloadingStrategy {

//     preload(route: Route, loadMe: () => Observable<any>): Observable<any> {

//     if (route.data && route.data['preload']) {
//       const delay:number=route.data['delay']
//       console.log('preload called on '+route.path+' delay is '+delay);
//       return timer(delay).pipe(
//         mergeMap( _ => {
//           console.log("Loading now "+ route.path);
//           return loadMe() ;
//         }));
//     } else {
//       console.log('no preload for the path '+ route.path);
//       return of(null);
//     }
//   }

// }
